// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle-percent-text-body {\n  width: 105% !important;\n  height: 90% !important;\n}\n.circle-percent-text-body>.percent-text {\n  font-size: 16px !important;\n  font-weight: 500 !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
